import ENUM from '@dpdgroupuk/redback-enums';

export default Object.freeze(ENUM.PARCEL_STATUS);
